import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ColillasTable from "../Colillas/ColillasTable"
import { ColillasView } from "./ColillasView"
import { ColillasDelete } from "./ColillasDelete"
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import IconButton from '@mui/material/IconButton';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';


import authService from '../api-authorization/AuthorizeService'
import { Breadcrumbs } from '../General/Breadcrumbs';

export class Colillas_Index extends Component {
    static displayName = Colillas_Index.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { nombre: "" }
        };
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="searchNombre">
                                        <FormattedMessage id='Nombre' />
                                    </Label>
                                    <FormattedMessage id='Nombre'>
                                        {(placeholder) =>
                                            <Input
                                                id="searchNombre"
                                                name="nombre"
                                                placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.searchModel.nombre}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <ColillasTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = [
            { link: "/Colillas", message: "Administrar", active: true },
            { link: "/Colillas", message: "Colillas", active: false },
        ];
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='Colillas' /></h2>
                <Breadcrumbs data={breadcrumbsData} />

                <div className="viewContainer">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true });
        const token = await authService.getAccessToken();
        var queryString = '?';
        Object.keys(this.state.searchModel).forEach(key => {
            queryString += key + "=" + this.state.searchModel[key] + "&";
        });
        queryString = queryString.slice(0, -1);
        const response = await fetch('api/colillas' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const responceData = await response.json();
        this.setState({ data: responceData, loading: false });
    }

    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, () => {

        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><ColillasView setModalBodyState={this.setModalBodyState}></ColillasView></div>);
        //return (<div><ColillasView ref={this.modalBodyState}></ColillasView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/colillas', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/colillas/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><ColillasView setModalBodyState={this.setModalBodyState} data={responceData}></ColillasView></div>);
        //return (<div><ColillasView ref={this.modalBodyState}></ColillasView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/colillas/' + this.modalBodyState.colilla_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/colillas/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><ColillasDelete setModalBodyState={this.setModalBodyState} data={responceData}></ColillasDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/colillas/' + this.modalBodyState.colilla_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
}